import React from "react";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-16">
      <span className="label text-cinnabar">About Us</span>
      <h1 className="font-serif font-light text-5xl sm:text-6xl tracking-tighter mt-4 mb-8">
        Bridging India & China, one learner at a time
      </h1>
      <div className="grid md:grid-cols-3 gap-10">
        <div className="md:col-span-2 space-y-5 text-lg text-clay leading-relaxed">
          <p>
            The <strong className="text-ink">Center for Chinese Language Pedagogy and Training (CCLPT)</strong> is
            dedicated to teaching Mandarin Chinese and training Indian educators to teach it well. Our programs span
            the full learner journey — from absolute beginner to advanced — all aligned to the new HSK 3.0 standard.
          </p>
          <p>
            Beyond language, we prepare teachers through our TCFL certificate and diploma programs, and we counsel
            students who aspire to study in China through university admissions and scholarships.
          </p>
          <p>
            Our blended approach combines expert instructors, a modern learning management system, and an always-on
            AI tutor — so every learner gets structure, feedback and practice.
          </p>
        </div>
        <div className="space-y-6">
          {[["6", "Programs"], ["HSK 3.0", "Aligned"], ["24/7", "AI Tutor"], ["1:1", "Feedback"]].map(([n, l], i) => (
            <div key={i} className="border-l-2 border-cinnabar pl-5">
              <p className="font-serif text-4xl text-ink">{n}</p>
              <p className="label text-clay mt-1">{l}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-16 border border-black/10 bg-white p-10 flex flex-col sm:flex-row items-center justify-between gap-6">
        <div>
          <h2 className="font-serif text-3xl">Our mission</h2>
          <p className="text-clay mt-2 max-w-xl">To make world-class Chinese language education accessible across India, and to build a community of skilled, confident Mandarin teachers.</p>
        </div>
        <Link to="/courses" className="px-7 py-4 bg-ink text-rice hover:bg-cinnabar transition-colors duration-300 whitespace-nowrap">Browse Courses</Link>
      </div>
    </div>
  );
}
